module.exports = __webpack_public_path__ + "img/04.dde38f14.png";